/**
 * Safely extract a human-readable error message from an Axios error.
 * Handles FastAPI/Pydantic v2 validation errors where detail is an array of
 * objects with { type, loc, msg, input, ctx } keys.
 */
export function getApiError(err: any, fallback: string): string {
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d: any) => (typeof d === 'string' ? d : d.msg || JSON.stringify(d))).join('; ');
  }
  if (typeof detail === 'object' && detail.message) return detail.message;
  return fallback;
}
